import React from 'react';
import { HTMLtoJSX } from '../../../../../../../helpers';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import styles from './Text.module.scss';

export interface TextProps {
  text: React.ReactNode;
}

export function Text({ text }: TextProps) {
  const { location } = useRootSelector(selectPageConfig);

  return <div className={styles.text}>{HTMLtoJSX(text, location)}</div>;
}
